import { useNavigate } from 'react-router-dom';
import ChevronLeft from './icons/ChevronLeft';

export default function BackButton() {
  const navigate = useNavigate();

  return (
    <button
      onClick={() => navigate(-1)}
      style={{
        position: 'absolute',
        top: '70px',
        left: '10px',
        zIndex: 10,
        padding: 0,
        background: 'none',
        color: 'var(--primary)',
        border: 'none',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <ChevronLeft size={28} />
    </button>
  );
}
